import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { get as _get } from 'lodash';
import cx from 'classnames';
import { Tooltip } from 'grab-ui';
import ChevronUpIcon from 'public/icons/chevron-up.svg';

import styles from './price-surge-icon.less';

export const PriceSurgeIcon = ({ className, priceSurgeInfo }) => {
  const priceIndicator = _get(priceSurgeInfo, ['priceIndicator']);

  if (!priceIndicator) {
    return null;
  }

  const description = _get(priceIndicator, ['description']);

  const priceSurgeIconRender = useMemo(
    () => (
      <img
        src={ChevronUpIcon}
        className={cx(className, styles.priceSurgeIcon)}
        alt="Price Surge Icon"
      />
    ),
    [priceIndicator],
  );

  return description ? (
    <Tooltip title={description} placement="bottomRight" trigger="hover">
      {priceSurgeIconRender}
    </Tooltip>
  ) : (
    priceSurgeIconRender
  );
};

PriceSurgeIcon.propTypes = {
  priceSurgeInfo: PropTypes.shape({}),
  className: PropTypes.string,
};

PriceSurgeIcon.defaultProps = {
  priceSurgeInfo: null,
  className: '',
};

export default {};
